import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../../assets/Icons";
import SecondaryButton from "../../../../../components/_utils/CommonButtons/SecondaryButton";
import CommonToast from "../../../../../components/_utils/CommonToast";
import ApprovalTopNavComponent from "../../../../../components/_utils/CommonTopNav/ApprovalTopNav";
import CardContainer from "../../../../../components/_utils/CommonViewAllCard/CardContainer";
import TextWithBank from "../../../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithBank";
import TextWithIcon from "../../../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";
import TickerAnimation from "../../../../../components/_utils/TickerAnimation";
import BeneScheduleTxnDeclinePopup from "../../../../../components/_utils/TransactionCommonComponents/CommonDeclinePopups/BeneScheduleTxnDeclinePopup";
import UniversalRefreshToast from "../../../../../components/_utils/UniversalRefreshToast";
import Loader from "../../../../../components/Loader/Index";
import {
  getCreateTransactionBalance,
  resetOwnerBalance,
} from "../../../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import { scheduledBeneficiaryApprove } from "../../../../../redux/features/transactions/scheduleBeneficiaryTransactions/index.js";
import {
  GlobalConfiguration,
  IntervalConfiguration,
} from "../../../../../utils/configurationProvider";
import "./index.css";
import ScheduleBeneficiaryTransactionDetailsPopup from "../../../../../components/Transactions/ScheduleBeneficiaryTransaction/ScheduleBeneficiaryTransactionDetailsPopup/index.jsx";
import UseHandleScroll from "../../../../../hooks/useHandleScroll";

const ScheduleBeneficiaryMultiApproval = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [txnId, setTxnId] = useState(null);
  const [deniedId, setDeniedId] = useState();
  const [loading, setLoading] = useState(false);
  const [refreshId, setRefreshId] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [PrevBalance, setPrevBalance] = useState(null);
  const [detailSelected, setDetailSelected] = useState("");
  const [failedRefreshId, setFailedRefreshId] = useState([]);
  const [refreshAnimation, setrefreshAnimation] = useState("");
  const [showTxnDetailPop, setShowTxnDetailPop] = useState(false);
  const [AllBeneTxnAccounts, setAllBeneTxnAccounts] = useState([]);
  const [transactionFilterID, setTransactionFilterID] = useState([]);
  const [transactionFilterData, setTransactionFilterData] = useState([]);

  const [direction, setDirection] = useState("");
  const lastScrollTop = useRef(GlobalConfiguration.lengthCheckZero);
  const { handleScroll } = UseHandleScroll(
    setDirection,
    lastScrollTop,
    GlobalConfiguration.beneSchTxnMultiApprCardHeight,
  );

  const services = useSelector((state) => state.refreshToken.services);

  const {
    createTransactionBankRefreshLoading,
    createTransactionBankRefreshError,
    createTransactionBankRefreshData,
  } = useSelector((state) => state.ownerAllVerification);

  const checkService =
    services?.includes("VAccountBalance") || services?.includes("Admin");

  useEffect(() => {
    const storedSelectedApproval = JSON.parse(
      sessionStorage.getItem("selectedscheduleData"),
    );

    if (storedSelectedApproval) {
      setTransactionFilterData(
        storedSelectedApproval?.selectedSendTransactions,
      );
      setTransactionFilterID(storedSelectedApproval.selectedTransactions);
    } else {
      setTransactionFilterData([]);
      setTransactionFilterID([]);
    }
  }, []);

  useEffect(() => {
    if (createTransactionBankRefreshLoading) {
      toast.dismiss();
      setTimeout(() => {
        UniversalRefreshToast();
      }, IntervalConfiguration?.intervalExtraSmall);
    } else if (createTransactionBankRefreshData?.status) {
      toast.dismiss();
      setTimeout(() => {
        CommonToast({
          text: "Balance refreshed successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
          },
        });
      }, 500);
      if (refreshId) {
        setFailedRefreshId((prev) =>
          prev.filter((failedId) => failedId !== refreshId),
        );
      }
    } else if (
      createTransactionBankRefreshError &&
      !createTransactionBankRefreshLoading
    ) {
      toast.dismiss();
      setTimeout(() => {
        CommonToast({
          text: createTransactionBankRefreshError,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
          },
        });
      }, 100);
      if (refreshId) {
        setFailedRefreshId((prev) => [...prev, refreshId]);
      }
    }
    if (createTransactionBankRefreshData) {
      let data = transactionFilterData.map((val) => {
        if (
          val.owner_account_id ===
          createTransactionBankRefreshData?.owner_accounts[0]?.owner_account_id
        ) {
          return {
            ...val,
            owner_account_balance:
              createTransactionBankRefreshData?.owner_accounts[0]
                ?.owner_account_balance,
            owner_account_balance_last_fetched_at_in_words:
              createTransactionBankRefreshData?.owner_accounts[0]
                ?.owner_account_balance_last_fetched_at_in_words,
          };
        }
        return val;
      });

      setTransactionFilterData(data);
      const selectedscheduleData = {
        selectedSendTransactions: data,
        selectedTransactions: transactionFilterID,
      };

      sessionStorage.setItem(
        "selectedscheduleData",
        JSON.stringify(selectedscheduleData),
      );
    }
    return () => {
      dispatch(resetOwnerBalance());
    };
  }, [
    createTransactionBankRefreshData,
    createTransactionBankRefreshLoading,
    createTransactionBankRefreshError,
    refreshAnimation,
    refreshId,
    dispatch,
    transactionFilterID,
    transactionFilterData,
  ]);

  const openBeneTxnDetailModal = () => {
    setShowTxnDetailPop(true);
  };
  const closeBeneTxnDetailModal = () => {
    setShowTxnDetailPop(false);
  };
  const handleBeneDetailPopupApprove = () => {
    let storedData = JSON.parse(sessionStorage.getItem("selectedscheduleData"));
    if (storedData) {
      const updatedTransactions = storedData.selectedSendTransactions.filter(
        (transaction) => transaction.txn_id !== txnId,
      );
      const updatedTransactionsId = storedData.selectedTransactions.filter(
        (transaction) => transaction !== txnId,
      );

      sessionStorage.setItem(
        "selectedscheduleData",
        JSON.stringify({
          ...storedData,
          selectedSendTransactions: updatedTransactions,
          selectedTransactions: updatedTransactionsId,
        }),
      );
      setTransactionFilterData(updatedTransactions);
      setTransactionFilterID(updatedTransactionsId);

      setTimeout(() => {
        setShowTxnDetailPop(false);
      }, 6000);
    }
  };

  const handleRefresh = (e, id, refreshTxnId, prevBalance) => {
    if (checkService) {
      e.stopPropagation();
      setPrevBalance(prevBalance);
      setrefreshAnimation(id);
      setRefreshId(refreshTxnId);
      setFailedRefreshId((prev) =>
        prev.filter((failedId) => failedId !== refreshTxnId),
      );

      dispatch(getCreateTransactionBalance(id));
    } else {
      e.stopPropagation();
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: "VAccountBalance,Admin",
        },
      });
    }
  };

  let total = transactionFilterData?.reduce(
    (acc, { amount }) => acc + Number(amount || 0),
    0,
  );

  const handleOpenPopup = (id) => {
    setShowPopup(true);
    setDeniedId(id);
  };

  const updateAllAccounts = (updatedAccounts) => {
    setAllBeneTxnAccounts(updatedAccounts);
  };

  const handleTxnApproval = async (id) => {
    setLoading(true);

    if (transactionFilterID.length > GlobalConfiguration?.lengthCheckZero) {
      const data = await dispatch(scheduledBeneficiaryApprove({ id }));
      setTimeout(() => {
        setLoading(false);
        toast.dismiss();
        if (data?.payload?.status === 500) {
          setTimeout(() => {
            CommonToast({
              text: data?.payload?.error,
              icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
              variant: "var(--error)",
              buttonNeeded: false,
              btnProps: {
                enabledBgColor: "var(--primary-bg)",
                enabledTextColor: "var(--text-primary)",
                btnText: "",
                handleFunction: () => {},
                icon: "",
                btnType: "button",
                isDisabled: false,
                hoverOption: "white",
              },
            });
          }, 1000);
        }
        if (data?.payload?.errors?.user_unauthorized?.[0]) {
          setTimeout(() => {
            navigate("/feature_not_assigned", {
              state: {
                unavailableService: "BAScheduledTxn",
              },
            });
          }, 1000);
        } else if (data?.payload?.status === true) {
          const selectedscheduleData = {
            selectedSendTransactions: data?.payload?.transactions,
            selectedTransactions: transactionFilterID,
          };

          sessionStorage.setItem(
            "selectedscheduleData",
            JSON.stringify(selectedscheduleData),
          );
          navigate(
            "/beneficiary_transaction_dashboard/schedule_multi_approval/schedules_multi_approval/schedules_multi_transaction_success",
          );
        } else if (data?.payload?.status === false) {
          navigate(
            "/beneficiary_transaction_dashboard/schedule_multi_approval/schedules_multi_approval/schedules_multi_transaction_error",
          );
        }
      }, 2000);
    }
  };

  const isNoTransactionSelected =
    transactionFilterData.length === GlobalConfiguration.lengthCheckZero;

  return (
    <>
      {showPopup && (
        <BeneScheduleTxnDeclinePopup
          allTxnData={AllBeneTxnAccounts}
          handleClose={() => setShowPopup(false)}
          txnId={deniedId}
          updateAllTxn={updateAllAccounts}
          flow="multiApproval"
          toastType="multiSchedule"
        />
      )}
      {showTxnDetailPop && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <ScheduleBeneficiaryTransactionDetailsPopup
            postRejectAdvice={handleBeneDetailPopupApprove}
            postApproveAdvice={handleBeneDetailPopupApprove}
            closeScheduleTxnDetailModal={closeBeneTxnDetailModal}
            txn_id={txnId}
            detailSelected={detailSelected}
          />
        </div>
      )}

      <div
        className="int-txn-mutli-details-main"
        style={{
          overflow: showPopup ? "hidden" : "",
          height: showPopup ? "var(--full-height)" : "",
        }}
      >
        {loading ? (
          <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
            <div className="flex justify-center items-center flex-col gap-gap-sm">
              <Loader />
              <div className="text-font-lg text-text-primary font-semibold">
                Approving schedules
              </div>
            </div>
          </div>
        ) : null}
        <div className="hidden Qmd:block min-h-[var(--navbar-breadcrumb-height)] h-navbar-breadcrumb-height bg-primary-nav"></div>
        <div className="int-txn-mutli-container relative z-z-index-tooltip">
          <ApprovalTopNavComponent
            direction={direction}
            topNavHeader={total}
            topNavSubText="Total amount"
            topNavCtaBtn1Needed={false}
            topNavCtaBtn1Props={{
              btnText: "Previous",
              btnType: "button",
              enabledBgColor: "var(--primary-nav-act)",
              handleFunction: () => navigate(-1),
              enabledTextColor: "var(--text-primary)",
              isDisabled: false,
              hoverOption: "white",
            }}
            topNavCtaBtn2Needed={false}
            topNavCtaBtnWithIcon1Props={{
              btnText: "Reject",
              handleFunction: () => {
                if (!isNoTransactionSelected) {
                  handleOpenPopup(transactionFilterID);
                }
              },
              enabledBgColor: "var(--negative-act)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS?.REJECT_ICON_RED_WITH_WHITE_CIRCLE,
              iconToBeAlign: "right",
              isDisabled: isNoTransactionSelected,
            }}
            topNavCtaBtnWithIcon2Props={{
              btnText: "Approve",
              handleFunction: () => {
                if (!isNoTransactionSelected) {
                  handleTxnApproval(transactionFilterID);
                }
              },
              enabledBgColor: "var(--positive-act)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS?.APPROVE_CIRCLE_GREEN_CHECKMARK,

              iconToBeAlign: "right",
              isDisabled: isNoTransactionSelected,
            }}
            BottomHeader={`Schedule approval process`}
            BottomSubText={`Below are the schedule's details. Approved schedules will generate transactions according to the specified frequency.`}
            isToggleNeeded={false}
            selectionBtnProps={{
              btnText: "View selected",
              btnType: "button",
              enabledBgColor: "var(--primary-nav-act)",
              handleFunction: () => {},
              enabledTextColor: "var(--text-primary)",
              isDisabled: false,
              icon: ICONS?.RELOAD_REFRESH_WHITE,
            }}
            iconComponentArray={[
              {
                enabledBgColor: "var(--primary-bg)",
                isLoading: loading,
                handleFunction: () => {},
                isDisabled: false,
                icon: ICONS?.RELOAD_REFRESH_WHITE,
                title: "Refresh schedules",
                hoverOption: "white",
              },
            ]}
            assignLabelNeeded={false}
            assignTagNeeded={false}
          />
        </div>
        <div
          className="h-full overflow-y-scroll relative Qmd:mb-margin-base mb-[var(--topnav-bottom-height)]"
          onScroll={handleScroll}
        >
          <h4 className="w-width-almost-full text-left text-font-md font-semibold text-text-primary mt-margin-md mx-auto whitespace-nowrap">
            Selected&nbsp;
            {transactionFilterData?.length === 1
              ? "Transaction"
              : "Transactions"}
            &nbsp;({transactionFilterData?.length})
          </h4>
          <div className="standard-card-alignment gap-gap-md ">
            {transactionFilterData?.map((val, i) => {
              return (
                <div
                  className=""
                  key={val?.txn_id || i}
                >
                  <CardContainer
                    isNoCursorRequired={true}
                    isDisabled={false}
                    isSelected={false}
                    onClickHandler={(e) => {
                      e.stopPropagation();
                    }}
                    isNoHoverRequired={true}
                  >
                    <card-body>
                      {val?.scheduled_name && (
                        <TextWithIcon
                          type={"Text"}
                          fontWeight={"semibold"}
                          text={val.scheduled_name}
                          textColor={"var(--text-primary)"}
                          subText="Schedule name"
                          iconComponentArray={
                            val.beneficiary_account_approval_status !==
                            "pending"
                              ? [
                                  ...(val?.confidential_transaction === "Y"
                                    ? [
                                        {
                                          icon: ICONS?.CONFIDENTIAL_TRANSACTION,
                                          title: "confidential",
                                          isDisabled: false,
                                        },
                                      ]
                                    : []),
                                ]
                              : []
                          }
                        />
                      )}
                      <TextWithIcon
                        type={"Amount"}
                        fontWeight={"semibold"}
                        text={val?.amount}
                        textColor={"var(--settled)"}
                        subText={"Amount"}
                      />
                      <TextWithIcon
                        type={"Text"}
                        fontWeight={
                          val.beneficiary_account_approval_status === "pending"
                            ? "var(--font-normal)"
                            : "var(--font-semibold)"
                        }
                        text={val.beneficiary_account_name}
                        textColor={"var(--text-primary)"}
                        subText="Account name"
                      />
                      <div className="relative">
                        <div className="flex flex-col gap-y-gap-xs pb-padding-button-l border-b-border mx-margin-sm border-primary-bg">
                          <p
                            className={`text-font-sm text-text-primary w-full truncate  font-normal `}
                          >
                            <TickerAnimation
                              text={val.frequency
                                .toLowerCase()
                                .split(" ")
                                .map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() +
                                    word.slice(1),
                                )
                                .join(" ")}
                            />
                          </p>
                          <div className="w-full   flex  justify-between items-center ">
                            <p
                              className={`text-font-xs w-width-md text-text-secondary transform-none  font-normal`}
                            >
                              Frequency
                            </p>
                            <div className="z-z-index-overlay absolute right-0 bottom-[1px]">
                              <SecondaryButton
                                btnText={
                                  val.beneficiary_account_approval_status ===
                                  "pending"
                                    ? "Approve account"
                                    : "Additional details"
                                }
                                handleFunction={(e) => {
                                  e.stopPropagation();
                                  openBeneTxnDetailModal();
                                  setTxnId(val.txn_id);
                                  setDetailSelected("Additional details");
                                }}
                                isDisabled={false}
                                enabledBgColor={"var(--text-primary)"}
                                enabledTextColor={"var(--primary-bg)"}
                                icon={ICONS?.ARROW_RIGHT_WHITE}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <TextWithBank
                        text={val.owner_account_bank_acc_no}
                        type={"AccountNumber"}
                        subText={"Source account"}
                        fontWeight={"normal"}
                        textColor={"var(--text-primary)"}
                        ifscCode={val?.owner_account_ifsc_code}
                      />

                      <TextWithIcon
                        type="Amount"
                        fontWeight={
                          Number(val?.owner_account_balance)
                            ? Number(val?.owner_account_balance) >=
                              Number(val?.amount)
                              ? "semibold"
                              : "semibold"
                            : "normal"
                        }
                        text={
                          val?.owner_account_balance
                            ? val?.owner_account_balance
                            : "Not available"
                        }
                        subText={"Balance"}
                        textColor={
                          val?.owner_account_balance !== null &&
                          val?.owner_account_balance !== undefined
                            ? val?.owner_account_balance === "xxxx.xx" ||
                              Number.isNaN(
                                Number(val?.owner_account_balance),
                              ) ||
                              Number(val?.owner_account_balance) >=
                                Number(val?.amount)
                              ? "var(--settled)"
                              : "var(--failed)"
                            : "var(--text-primary)"
                        }
                        iconComponentArray={[
                          ...(function () {
                            let iconUrl = "";
                            let titleText = "";

                            if (
                              createTransactionBankRefreshLoading &&
                              refreshId === val?.txn_id
                            ) {
                              iconUrl = ICONS?.LOADER_GIF;
                              titleText = "Balance updating";
                            } else if (failedRefreshId.includes(val?.txn_id)) {
                              iconUrl = ICONS?.ERROR_WITH_ORANGE_CIRCLE;
                              titleText = "Balance fetch failed";
                            } else if (
                              !createTransactionBankRefreshLoading &&
                              refreshId === val?.txn_id &&
                              val?.owner_account_id === refreshAnimation &&
                              PrevBalance !== undefined &&
                              Number(val?.owner_account_balance) !==
                                Number(PrevBalance)
                            ) {
                              if (
                                Number(val?.owner_account_balance) >
                                Number(PrevBalance)
                              ) {
                                iconUrl = ICONS?.ARROW_UP_GREEN_GIF;
                                titleText = "Balance updated";
                              } else if (
                                Number(val?.owner_account_balance) <
                                Number(PrevBalance)
                              ) {
                                iconUrl = ICONS?.ARROW_DOWN_RED_GIF;
                                titleText = "Balance updated";
                              }
                            }

                            return iconUrl
                              ? [
                                  {
                                    icon: iconUrl,
                                    title: titleText,
                                    isDisabled: false,
                                  },
                                ]
                              : [];
                          })(),
                          ...(() => {
                            if (checkService)
                              return [
                                {
                                  icon: ICONS?.RELOAD_REFRESH_WHITE,
                                  title: "Refresh balance",
                                  isDisabled: !checkService,
                                  onClick: (e) => {
                                    if (
                                      !createTransactionBankRefreshLoading ||
                                      refreshId !== val?.txn_id
                                    ) {
                                      if (checkService) {
                                        handleRefresh(
                                          e,
                                          val?.owner_account_id,
                                          val?.txn_id,
                                          val?.owner_account_balance,
                                        );
                                      } else {
                                        e.stopPropagation();
                                        navigate("/feature_not_assigned", {
                                          state: {
                                            unavailableService:
                                              "VAccountBalance,Admin",
                                          },
                                        });
                                      }
                                    } else {
                                      e.stopPropagation();
                                    }
                                  },
                                  bgColor: "var(--primary-nav)",
                                },
                              ];
                            return [];
                          })(),
                        ]}
                      />
                    </card-body>
                  </CardContainer>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default ScheduleBeneficiaryMultiApproval;
